import React, { useEffect } from "react";
import HomeMain from "./HomeMain";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import footerLogo from "../../assets/images/logos/footer-logo.png";

import useStore from "../../store/information";
import { SERVER_URL } from "../../api/url";
import axios from "axios";

const HomePage = () => {
  const { setTotalInfo } = useStore();
  


  const fetchInfo = async () => {
  
    try {
      const response = await axios.get(`${SERVER_URL}/bank`);
      const fetchedData = response.data?.data || [];
    setTotalInfo(fetchedData[0])
    localStorage.setItem('ph1', fetchedData[0]?.phoneNumber);
    localStorage.setItem('email', fetchedData[0]?.email);
    // localStorage.setItem('ph2', fetchedData[0]?.names?.[4]?.name);
    localStorage.setItem('address', fetchedData[0]?.names?.[4]?.name);
  
    } catch (err) {
      console.error(err.response);
     
    } 
  };
  useEffect(() => {
    fetchInfo();
  }, []);
  return (
    <>
      <Header parentMenu="home" topbarEnable="enable" />
      <HomeMain />
      <Footer footerLogo={footerLogo} />
    </>
  );
};

export default HomePage;
